import { AdminLayout } from "@/views/layouts/AppLayout";
import { Navigate } from "react-router";
import {
    AiHistoricalDialogueDetailPage,
    AiHistoricalDialoguePage
} from "@/views/pages/intelligentAssistant/AiHistoricalDialoguePage";
import { AiCorpusPublishPage } from "@/views/pages/intelligentAssistant/AiCorpusPublishPage";
import { AiCorpusPublishDetailPage } from "@/views/pages/intelligentAssistant/AiCorpusPublishDetailPage";
import { AiCorpusPublishFormPage } from "@/views/pages/intelligentAssistant/AiCorpusPublishFormPage";
import { AiCorpusLibraryPage } from "@/views/pages/intelligentAssistant/AiCorpusLibraryPage";
import { AiHotWordPage } from "@/views/pages/intelligentAssistant/AiHotWordPage";
import { AiHotWordUploadPage } from "@/views/pages/intelligentAssistant/AiHotWordUploadPage";
import type { AdminRouteObject } from "../index";

/** 智能助理路由，保留 Vue AI历史对话列表和隐藏详情入口。 */
export const intelligentAssistantRoutes: AdminRouteObject = {
    path: "/intelligentAssistant",
    element: <AdminLayout />,
    handle: { title: "智能助理" },
    children: [
        {
            // 沿用旧 Vue 根路由，进入智能助理时默认打开 AI 热词页面。
            index: true,
            element: <Navigate replace to="aiHotWord" />
        },
        {
            path: "aiHistoricalDialogue",
            element: <AiHistoricalDialoguePage />,
            handle: { title: "AI历史对话", permissions: ["ROLE_ASSISTANTS"] }
        },
        {
            path: "aiHistoricalDialogue/:id",
            element: <AiHistoricalDialogueDetailPage />,
            handle: { title: "AI历史对话详情", permissions: ["ROLE_ASSISTANTS"] }
        },
        {
            path: "aiCorpus/publish",
            element: <AiCorpusPublishPage />,
            handle: { title: "AI语料发布", permissions: ["ROLE_ASSISTANTS_CORPUS_W"] }
        },
        {
            path: "aiCorpus/publish/info/:id",
            element: <AiCorpusPublishDetailPage />,
            handle: { title: "AI语料发布详情", permissions: ["ROLE_ASSISTANTS_CORPUS_W"] }
        },
        {
            path: "aiCorpus/publish/add",
            element: <AiCorpusPublishFormPage />,
            handle: { title: "新增AI语料发布", permissions: ["ROLE_ASSISTANTS_CORPUS_W"] }
        },
        {
            path: "aiCorpus/publish/edit/:id",
            element: <AiCorpusPublishFormPage />,
            handle: { title: "编辑AI语料发布", permissions: ["ROLE_ASSISTANTS_CORPUS_W"] }
        },
        {
            path: "aiCorpus/library",
            element: <AiCorpusLibraryPage />,
            handle: { title: "AI语料库", permissions: ["ROLE_ASSISTANTS_CORPUS_W"] }
        },
        {
            path: "aiHotWord",
            element: <AiHotWordPage />,
            handle: { title: "AI热词", permissions: ["ROLE_ASSISTANTS_WORDS"] }
        },
        {
            path: "aiHotWord/upload/:tip",
            element: <AiHotWordUploadPage />,
            handle: { title: "AI热词批量导入", permissions: ["ROLE_ASSISTANTS_WORDS"] }
        }
    ]
};

export default intelligentAssistantRoutes;
